﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";       
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";

export class JobWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private debug: boolean = false; 
    private fileName: string;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.init();            
    }

    init() {
        let th = this;
        $('[data-name=btnSubmitDenial]').off();
        $('[data-name=btnSubmitDenial]').on("click", (ev: Event) => th.submitDenial(ev));

        $('.btnSubmitSignJob').off();
        $('.btnSubmitSignJob').on("click", (ev: Event) => th.sign(ev));

        //let submitSignBtns = $('.btnSubmitSignJob');
        //if (submitSignBtns.length > 0) {
        //    submitSignBtns.each(function (index, el) {
        //        el.onclick = (ev: Event) => th.sign(ev);
        //    });
        //}
          
        $('[data-name=btnDownloadDocument]').off();
        $('[data-name=btnDownloadDocument]').on("click", (ev: Event) => th.downloadDocument(ev));
        
        $('[data-name=btnDownload]').off();
        $('[data-name=btnDownload]').on("click", (ev: Event) => th.download(ev));

        $('[data-name=btnDelete]').off("click");
        $('[data-name=btnDelete]').on("click", (ev: Event) => th.onDeleteBtnClick(ev,this));

        //$('#deleteForm').on("submit", (ev:Event)=>th.onDeleteBtnClick(ev, ev.currentTarget))
        
        this.checkPostSignature();
        this.checkPostDeletion();
    }

    //denial
    async submitDenial(ev: Event) {
        ev.preventDefault();
        this._showLoader();
        this._debugging("submitting documents");
        //let id = $(ev.target).data("id");        
        let url = $(ev.currentTarget).data("url");
        let formElement = $(ev.target).closest("form");
        this._debugging(formElement);
        let el = $(`.table-wrap.signt`);
        let inputField = $(formElement).find("input[name='RazlogZavrnitve']");
        

        //unobtrusive
        formElement.validate();
        $.validator.messages.required = inputField.attr("errormessage");
        $(inputField).rules('add', { required: true });
        if (!formElement.valid()) {
            this._hideLoader();
            return false;
        }
        
        let data = formElement.serializeArray();
        

        this._debugging("ready to post");
        this._debugging(data);                       

        await this.service.PostObject(data, el, url, this.statusBarWidget);
        this.statusBarWidget.setStatus($(ev.currentTarget).data("success"), "ok");
        this._hideLoader();
        $(ev.target).closest('.modal').modal('toggle');
        this._debugging("posted");
        this.init();
        window.location.reload();
    }

    sign(ev: Event) { 
        ev.preventDefault();
        this._debugging("sign");

        let mobile = $(ev.currentTarget).data("mobile") != false;
        let jobId = $(ev.currentTarget).data("jobId");
        let signerId = $(ev.currentTarget).data("signerId");
        let url = $(ev.currentTarget).data("url");
        

        this.signDocuments(jobId, signerId, mobile, url);
        //th.checkSignOptions(ids)
        //    .then((options) => th.signDocuments(jobId, signerId, options))
    }
    
    getDocument(url, id) {          
        try {
            this._debugging("getDocument");
            let th = this;
            return new Promise(function (resolve) {
                let self = th;
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: { idZahtevka: id },
                    cache: false,
                    xhrFields: {
                        withCredentials: true
                    } ,
                    xhr: function () {
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState == 2) {
                                if (xhr.status == 200) {
                                    xhr.responseType = "blob";
                                } else {
                                    xhr.responseType = "text";
                                }
                            }
                        };
                        return xhr;
                    },
                }).done((data) => resolve(data))
                    .fail((xhr, status, error) => self.service.onPostFail(xhr, status, error, self.statusBarWidget))
            });
        } catch (e) {
            console.log(e);
        }
    }
    setModalDoc(data: any, signatureService: SignatureWidget, signeeCount:number) {
        this._debugging("setModalDoc");
        let th = this;
        var blob = new Blob([data], { type: "application/octetstream" });
        this._hideLoader();
        signatureService.initPdf(blob, signeeCount);
        return new Promise(function (resolve) {
            $(".confirmrect").one("click", function (ev: any) {
                th._showLoader();
                resolve(true);
            })  
            $('#signature-modal').one('hide.bs.modal', function (e) {
                th._debugging("destroy canvas");
                var canvas = (document.getElementById('the-canvas') as HTMLCanvasElement);
                canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                $("#canvas").children().remove();
                $('#prev').off();
                $('#next').off();
            })
        });
    }
    
    checkSignOptions(ids) {
        this._debugging("checkSignOptions");
        let th = this;
        let modal = $("#sign-options-modal");
        return new Promise(async function (resolve) {
            th._showLoader();
            let html = await th.getOptionsModal(ids, modal);
            th._debugging(html);
            if (html == null || html == "") { resolve(true) }
            else {
                modal.modal('show');
                th._hideLoader();

                $(".confirm-options").one("click", function (ev: any) {
                    th._showLoader();
                    var data = { "ContinueWith": $(ev.currentTarget).data("value") };
                    modal.modal('hide');
                    resolve(data);
                })
            }
        });
    }
    getOptionsModal(ids: any, el: JQuery<HTMLElement>) {
        let th = this;
        return new Promise<string>(function (resolve) {
            let data = JSON.stringify({ ids: ids });
            let self = th;
            th.service.PostView(data,el, "check-user-options", th.statusBarWidget).done((html) => resolve(html))
        });
    }

    async signDocuments(jobId: string, signerId: string, mobileApp: boolean, url: string) {    
        let data = JSON.stringify({ JobId: jobId, SignerId: signerId, CallBack: window.location.href, ContinueWith: mobileApp ? "False" : "True", PravnaOseba: "0" });
        let th = this;
        this._showLoader();
        this._debugging("posting: " + data.toString() + " to: " + url)
        // make ajax call

        $.ajax({
            url: url,
            type: "POST",
            data: data,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false
        })
        .done((response) =>
        {
            if (response.success) {
                window.location.href = response.redirectUrl;
            }
            else {
                this._hideLoader();
                this.statusBarWidget.setStatus(response.message, "bad")
            }
        })
        .fail((xhr) => {
            this._hideLoader();
            this.statusBarWidget.setStatus("Interna napaka strežnika", "bad")    
        });
        //var signUrl = await this.service.PostJson(data, url, this.statusBarWidget);
        //this.onPostSignDone(signUrl);
    }

    onPostSignDone(PodpisUrl: any) {
        let self = this;
        this._debugging("post done: " + PodpisUrl.toString());

        location.href = PodpisUrl;
        window.addEventListener("message", function (event) {
            if (event.origin === PodpisUrl) {
                alert("Response from Rekono: " + event.data);
                self._hideLoader();
            }
        });

    }

    download(ev: Event) {       
        ev.preventDefault();
        let id = $(ev.currentTarget).data("id");
        let signed = $(ev.currentTarget).data("signed") === "True";
        let url = $(ev.currentTarget).data("url");
        this.fileName = $(ev.currentTarget).data("filename");
        if (signed) {
            this.fileName = this.fileName.replace(".pdf", ".signed.pdf");
        }
        let th = this;
        th._showLoader();
        th.getDocument(url, id).then((data: Blob) => {
            let blob = new Blob([data], { type: "application/octetstream" });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = th.fileName;
            link.click();
            this._hideLoader();
            
        });
    }


    downloadDocument(ev: Event) {
        ev.preventDefault();
        let id = $(ev.currentTarget).data("id");
        let url = $(ev.currentTarget).data("url");
        let th = this;
        th._showLoader();
        let signed = $(ev.currentTarget).closest(".custom-table").hasClass("signd");
        let signatureService: SignatureWidget = new SignatureWidget($("#preview-widget") as unknown as HTMLElement,1,1);
        $("#preview-modal").modal('toggle');
        return new Promise((resolve) => {
            th.getDocument(url, id)
                .then((data: any) => {
                    var blob = new Blob([data], { type: "application/octetstream" });
                    this._hideLoader();
                    signatureService.initPdfPreview(blob);
                    $('[data-name=docSlider]').off('input');         //TODO
                    $('[data-name=docSlider]').on('input', function (ev: Event) {
                        var scale = $(ev.currentTarget).val();
                        $('.canvas-wrapper').css('transform', `scale(${scale}, ${scale})`);
                    }) 
                    th._hideLoader();
                    $('#preview-modal').one('hide.bs.modal', function (e) {
                        th._debugging("destroy canvas");
                        var canvas = (document.getElementsByClassName('the-canvas')[0] as HTMLCanvasElement);
                        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                        $('.prev').off();
                        $('.next').off();
                    })
                })
        })
    }
    checkPostSignature() {
        let postElement = $('#postSignature');
        if (postElement.length > 0) {
            if (postElement.data("num") == 1) this.statusBarWidget.setStatus(postElement.data("text"), "ok");
            if (postElement.data("num") == 2) this.statusBarWidget.setStatus(postElement.data("text"), "bad");
            if (postElement.data("num") == 3) this.statusBarWidget.setStatus(postElement.data("text"), "bad");
        }
    }

    async onDeleteBtnClick(e: Event, formElement) {
        e.preventDefault();
        let th = this;
        if (await th.modalConfirm()) {
            this._showLoader();
            let serviceUrl = $(e.target).data("url");
            if (!serviceUrl) {
                this.statusBarWidget.setStatus("Napaka", "bad");
                return;
            }
            // make ajax call
            $.ajax({
                url: serviceUrl,
                type: "GET",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                cache: false
            }).done((response) => {
                if (!response) {
                    this._hideLoader();
                    this.statusBarWidget.setStatus("Napaka", "bad");
                    return;
                }
                else if (response.success) {
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                        return;
                    }
                    else {
                        window.location.reload();
                        return;
                    }
                }
                else {
                    this._hideLoader();
                    this.statusBarWidget.setStatus(response.message, "bad");
                }
            }).fail((xhr) => {
                this._hideLoader();
                this.statusBarWidget.setStatus(xhr.status + " " + xhr.statusText, "bad");
            });
            //formElement.submit(); 
        }
        //if (await th.modalConfirm()) {
        //    th._showLoader();
        //    let link = $(e.currentTarget).attr('href');  
        //    let url = `${link}`;
        //    let el = $("[data-content=table-rows]");
        //    await th.service.GetView(url, el, th.statusBarWidget);
        //    //window.location.href = url;                  
        //    th._hideLoader();
        //}
    }

    async modalConfirm(): Promise<any> {
        return new Promise((resolve) => {
            $('#confirmYes').off('click');
            $('#confirmNo').off('click');

            $('#confirmYes').on('click', () => {
                $('#confirm').modal("hide");
                resolve(true);
            });

            $('#confirmNo').on('click', () => {
                $('#confirm').modal("hide");
                resolve(false);
            });

            $('#confirm').modal("show");
        });
        //const ui = {
        //    confirm: async (message) => createConfirm(message)
        //}

        //const createConfirm = (message) => {
        //    return new Promise((complete, failed) => {

        //        $('#confirmYes').off('click');
        //        $('#confirmNo').off('click');

        //        $('#confirmYes').on('click', () => { $('#confirm').modal("hide"); complete(true); });
        //        $('#confirmNo').on('click', () => { $('#confirm').modal("hide"); complete(false); });

        //        $('#confirm').modal("show");
        //    });
        //}

        //const confirm = await ui.confirm('');
        //return confirm;

    }

    checkPostDeletion() {
        let postElement = $('#postDeletion');
        if (postElement.length > 0) {
            this.statusBarWidget.setStatus(postElement.data("text"), "ok");
        }        
    }
    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
}
